import {
  Installation,
  LockerPosition,
  PackageCandidate,
} from '../../models/microservices';
import {
  LockerState,
  KioskDataState,
  SessionState,
  DevicesState,
} from './stateTypes';

export interface SessionInitialStates {
  normalState: SessionState;
}
export interface KioskDataInitialStates {
  normalState: KioskDataState;
}
export interface LockerInitialStates {
  normalState: LockerState;
}
export interface DevicesInitialState {
  normalState: DevicesState;
  bypassState: DevicesState;
}
interface InitialStates {
  session: SessionInitialStates;
  kioskData: KioskDataInitialStates;
  locker: LockerInitialStates;
  devices: DevicesInitialState;
}

export const initialStates: InitialStates = {
  kioskData: {
    normalState: {
      installation: {} as Installation,
    },
  },
  session: {
    normalState: {
      dhlApiToken: '',
      dhlAgentToken: '',
      tokenExpirationTime: 0,
      tokenExpired: false,
      showExitModal: false,
      showUserInactivityModal: false,
      userInactivitySeconds: 0,
      needsSessionOpen: false,
      authenticating: true,
      authErrorMessage: '',
      needsLogin: false,
      language: 'es',
    },
  },
  locker: {
    normalState: {
      isMultiDelivery: false,
      isAgentProcess: false,
      employeeNumber: '',
      customerName: '',
      customerSignature: '',
      lockerRackId: 0,
      lockerContent: [] as LockerPosition[],
      currentLockerPosition: {} as LockerPosition,
      currentPackageCandidate: {} as PackageCandidate,
      lockerRemoveList: [] as LockerPosition[],
    },
  },
  devices: {
    normalState: {
      logger: null,
      scanner: null,
      locker: null,
      settingUpScanners: true,
      settingUpLocker: true,
    },
    bypassState: {
      logger: null,
      scanner: null,
      locker: null,
      settingUpScanners: false,
      settingUpLocker: false,
    },
  },
};
